import React, { useEffect, useRef, useState } from "react";
import { getMonthNames } from "helper/tools";

import "./metas.css";

import "../daterangepicker.css";

import "chartjs-plugin-dragdata";

import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";

import { PermissionsForSection } from "../auth";
import { Sections } from "../../data/navItem";
import MetaBuilder from "./MetaBuilder";

export default function MetasDashboardTable({
  handleSortChange,
  //  isLoading = false,
}) {
  const dateRangeRef = useRef();
  const dateRangeEleRef = useRef();

  const thisMonthDateRef = useRef("");

  const [isLoading, setIsLoading] = useState(false);
  const [permissions, setPermissions] = useState({
    canCreate: true,
    canEdit: true,
    canVerDetalle: true,
  });

  const [startDate, setStartDate] = useState();
  const [endDate, setEndDate] = useState();

  useEffect(() => {
    fetchData();

    const newPermissions = PermissionsForSection(Sections.Asociados);
    setPermissions(newPermissions);

    configureDatePicker();
  }, []);

  const configureDatePicker = () => {
    const now = new Date();
    const yesterday = new Date(now);
    yesterday.setDate(yesterday.getDate() - 1);
    const daysBack7 = new Date(now);
    daysBack7.setDate(daysBack7.getDate() - 6);
    const daysBack30 = new Date(now);
    daysBack30.setDate(daysBack30.getDate() - 29);

    const thisMonthStart = new Date(now);
    thisMonthStart.setDate(1);
    const thisMonthEnd = new Date(thisMonthStart);
    thisMonthEnd.setMonth(thisMonthEnd.getMonth() + 1);
    thisMonthEnd.setDate(-1);

    const lastMonthStart = new Date(now);
    lastMonthStart.setDate(1);
    lastMonthStart.setMonth(lastMonthStart.getMonth() - 1);
    const lastMonthEnd = new Date(lastMonthStart);
    lastMonthEnd.setMonth(lastMonthEnd.getMonth() + 1);
    lastMonthEnd.setDate(-1);

    setStartDate(lastMonthStart);
    setEndDate(lastMonthStart);

    const lastYearStart = new Date(now);
    lastYearStart.setDate(1);
    lastYearStart.setMonth(0);
    lastYearStart.setFullYear(lastYearStart.getFullYear() - 1);

    const lastYearEnd = new Date(lastYearStart);
    lastYearEnd.setFullYear(lastYearStart.getFullYear() + 1);
    lastYearEnd.setDate(-1);

    const sameMonthDifAge = new Date(now);
    sameMonthDifAge.setDate(sameMonthDifAge.getFullYear() - 1);

    dateRangeRef.current = new window.daterangepicker(
      dateRangeEleRef.current,
      {
        locale: {
          customRangeLabel: "Rango Personalizado",
        },
        singleDatePicker: false,
        showDropdowns: true,
        showCustomRangeLabel: true,
        showWeekNumbers: true,

        minDate: startDate,
        //maxYear: now.getFullYear(), // parseInt(moment().format('YYYY'),10)

        timePicker: false,
      },
      function (start, end, label) {
        setStartDate(start);
        setEndDate(end);
      },
    );
  };

  const fetchData = async () => {};

  ChartJS.register(
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend,
  );

  //"August 27, 2025 - August 27, 2025";

  return (
    <>
      <div className="container">
        <div className="row">
          <MetaBuilder
            title={"Mes Actual"}
            subtitle={thisMonthDateRef.current}
          />
        </div>
      </div>

      <div className="bd-example bd-example-row">
        <div className="container">
          <div className="row"></div>
        </div>
      </div>
    </>
  );
}
